module.exports = __webpack_public_path__ + "img/calendar.a080ec20.png";